<template>
  <div class="hidden">
    <div ref="tag" :class="`price-tag ${setColor.off}`">
      <div class="price-tag-wrapper">
        <span :class="`plate ${active ? setColor.on : setColor.off}`">
          <slot></slot>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VMarker",
  props: ['position', 'mark', 'active', 'color'],
  inject: ['maps', 'marker', 'map'],
  data() {
    return {
      element: null,
      content: null
    }
  },
  computed: {
    setColor() {
      switch (this.color) {
        case 'Azul':
          return {
            on: 'text-white bg-blue-voltex-40',
            off: 'bg-white text-blue-voltex-40'
          }
        case 'Azul oscuro':
          return {
            on: 'text-white bg-blue-dark-80',
            off: 'bg-white text-blue-dark-80'
          }
        default:
          return {
            on: 'text-white bg-primary-0',
            off: 'bg-white text-primary-0'
          }

      }
    }
  },
  watch: {
    active(a) {
      if (this.element)
        this.element.zIndex = a ? 1 : 0;
    }
  },
  mounted() {
    if (!this.mark) {
      this.content = this.$refs['tag'];
    }
    this.element = new this.marker.AdvancedMarkerElement({
      map: this.map,
      position: this.position,
      content: this.content
    });

    this.element.addListener("gmp-click", () => {
      this.$emit("click");
    })

    this.$el.classList.add("hidden");
  },
  destroyed() {
    if (this.element)
      this.element.setMap(null);
  }
}
</script>

<style lang="scss" scoped></style>